/* eslint-disable max-len */
import React from 'react';
import RoleCard from '../RoleCard';
import Styles from './RolesCardContainer.module.scss';

interface IRolesCardContainer{
  defaultData:any;
  handleDropdown:any;
  customData:any
  handleCheckCard?:any;
}
const RolesCardContainer = ({
  defaultData, handleDropdown, customData, handleCheckCard,
}:IRolesCardContainer) => (
  <div className={Styles.wrapper}>
    <div className={Styles.wrapper__title}>Default Roles</div>
    <div className="row">
      <div className="col-lg-4">
        <RoleCard data={defaultData} handleDropdown={handleDropdown} hideCheckBox />
      </div>
    </div>
    <div className={Styles.wrapper__customTitle}>Custom Roles</div>
    <div className="row">
      {
        customData?.map((list:any) => (
          <div className={` ${Styles.wrapper__customCard} col-lg-4`} key={list?.id}>
            <RoleCard data={list} handleDropdown={handleDropdown} handleCheckCard={handleCheckCard} />
          </div>
        ))
      }

    </div>
  </div>
);

export default RolesCardContainer;
